import React, { useEffect, useState } from "react";
import styles from "./dropdown-black-background.module.scss";
const cssClassName = "dropdown-black-background";

interface DropDownBlackBackgroundPropTypes {
  id: string;
  dropDownValue: string;
  dropDownValuesAndLabels: { [key: string]: string };
  callback: (value: string) => void;
}

export const DropDownBlackBackground = ({
  id,
  dropDownValue,
  dropDownValuesAndLabels,
  callback,
}: DropDownBlackBackgroundPropTypes) => {
  const [localValue, setLocalValue] = useState(dropDownValue);

  const handleChange = (value) => {
    setLocalValue(value);
    callback(value);
  };

  useEffect(() => {
    setLocalValue(dropDownValue);
  }, [dropDownValue]);

  return (
    <select
      id={id}
      value={localValue}
      onChange={(e) => handleChange(e.target.value)}
      className={styles[cssClassName]}
    >
      {dropDownValuesAndLabels &&
        Object.entries(dropDownValuesAndLabels).map(([value, label]) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
    </select>
  );
};
